import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { Container, theme } from "./styles";
export { ArticleThemeSignUpButtonDisplay } from "./article-theme-sign-up-button-display";
export { ArticleThemeTitle } from "./article-theme-title";
export * from "./hooks";
export const ArticleTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "article-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
ArticleTheme.displayName = "ArticleTheme";